import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import ProductCard from "./ProductCard";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import axios from "axios";
import idioma_lbl from "./index";

const rutinas = [
  { name_en: "Hydration", name_es: "Hidratación" },
  { name_en: "Brightness", name_es: "Luminosidad" },
  { name_en: "No spots", name_es: "Libre de manchas" },
  { name_en: "Reduced pores", name_es: "Poros reducidos" },
  { name_en: "Elastic skin", name_es: "Piel elástica" },
  { name_en: "Eye contour", name_es: "Contorno de ojos" },
  { name_en: "No black heads", name_es: "Libre de granos" },
  { name_en: "No imperfections", name_es: "Libre de imperfecciones" }
];

export default function Results({ choices, purpose }) {
  const age = choices.Edad;
  const skin = choices.Piel;
  const has_second_routine = purpose.length > 1 ? true : false;
  const [products_ids, setProductsIds] = React.useState([]);
  const [routine_ids, setRoutineIds] = React.useState([]);
  const [products_api, setProductsApi] = React.useState([]);
  const [querydone, setQueryDone] = React.useState(false);

  const evaluate_purpose = (routines_array, age, skin) => {
    let prod_array = [];
    let rutina_array = [];
    for (var routine of routines_array) {
      switch (true) {
        case routine === "hidratada":
          rutina_array.push(rutinas[0]);
          if (idioma_lbl === "en") {
          prod_array.push(10276); //ha b5 mask
          prod_array.push(10338); //ha hibiscus
          } else {
          prod_array.push(9990); //ha b5 mask
          prod_array.push(9915); //ha hibiscus
          }
          break;
        case routine === "luminosa":
          rutina_array.push(rutinas[1]);
          if (skin === "seca" || skin === "sensible") {
          if (idioma_lbl === "en") {
            prod_array.push(10406); //vit c gag
            prod_array.push(10338); //ha hibiscus
            } else {
            prod_array.push(195); //vit c gag
            prod_array.push(9915); //ha hibiscus
            }
          } else if (skin === "grasa" || skin === "mixta") {
            if (idioma_lbl === "en") {
            prod_array.push(10406); //vit c gag
            prod_array.push(10274); //salicylic biome
            } else {
            prod_array.push(195); //vit c gag
            prod_array.push(9946); //salicylic biome
            }
          } else {
            if (idioma_lbl === "en") {
            prod_array.push(10406); //vit c gag
            prod_array.push(10409); //multivit
            } else {
            prod_array.push(195); //vit c gag
            prod_array.push(196); //multivit
            }
          }
          break;
        case routine === "sinmanchas":
          rutina_array.push(rutinas[2]);
          if (skin === "fotoenvejecida" || skin === "seca") {
            if (idioma_lbl === "en") {
            prod_array.push(10419); //niacinamide
            prod_array.push(10409); //multivit
            } else {
            prod_array.push(199); //niacinamide
            prod_array.push(196); //multivit
            }
          } else if (skin === "grasa" || skin === "mixta") {
            if (idioma_lbl === "en") {
            prod_array.push(10419); //niacinamide
            prod_array.push(10429); //glycolic aha
            } else {
            prod_array.push(199); //niacinamide
            prod_array.push(201); //glycolic aha
            }
          } else {
            if (idioma_lbl === "en") {
            prod_array.push(10419); //niacinamide
            prod_array.push(10338); //ha hibiscus
            } else {
            prod_array.push(199); //niacinamide
            prod_array.push(9915); //ha hibiscus
            }
          }
          break;
        case routine === "sinporos":
          rutina_array.push(rutinas[3]);
          if (idioma_lbl === "en") {
          prod_array.push(10419); //niacinamide
          prod_array.push(10274); //salicylic biome
          } else {
          prod_array.push(199); //niacinamide
          prod_array.push(9946); //salicylic biome
          }
          break;
        case routine === "sinarrugas":
          rutina_array.push(rutinas[4]);
          if (skin === "fotoenvejecida" || skin === "seca") {
            if (idioma_lbl === "en") {
            prod_array.push(10416); //retinol 015
            prod_array.push(10395); //ceramides cream
            } else {
            prod_array.push(198); //retinol 015
            prod_array.push(9991); //ceramides cream
            }
          } else if (skin === "grasa" || skin === "mixta") {
            if (idioma_lbl === "en") {
            prod_array.push(10416); //retinol 015
            prod_array.push(10274); //salicylic biome
            } else {
            prod_array.push(198); //retinol 015
            prod_array.push(9946); //salicylic biome
            }
          } else {
            if (idioma_lbl === "en") {
            prod_array.push(10416); //retinol 015
            prod_array.push(10338); //ha hibiscus
            } else {
            prod_array.push(198); //retinol 015
            prod_array.push(9915); //ha hibiscus
            }
          }
          break;
        case routine === "contornoojos":
          rutina_array.push(rutinas[5]);
          if (idioma_lbl === "en") {
          prod_array.push(10416); //retinol 015
          prod_array.push(10284); //vit k serum
          } else {
          prod_array.push(198); //retinol 015
          prod_array.push(203); //vit k serum
          }
          break;
        case routine === "singranos":
          rutina_array.push(rutinas[6]);
          if (skin === "seca") {
            if (idioma_lbl === "en") {
            prod_array.push(10419); //niacinamide
            prod_array.push(10274); //salicylic biome
            } else {
            prod_array.push(199); //niacinamide
            prod_array.push(9946); //salicylic biome
            }
          } else if (skin === "fotoenvejecida") {
            if (idioma_lbl === "en") {
            prod_array.push(10416); //retinol 015
            prod_array.push(10274); //salicylic biome
            } else {
            prod_array.push(198); //retinol 015
            prod_array.push(9946); //salicylic biome
            }
          } else {
            if (idioma_lbl === "en") {
            prod_array.push(10413); //salicylic serum
            prod_array.push(10274); //salicylic biome
            } else {
            prod_array.push(197); //salicylic serum
            prod_array.push(9946); //salicylic biome
            }
          }
          break;
        case routine === "sinmarcas":
          rutina_array.push(rutinas[7]);
          if (skin === "grasa" || skin === "mixta") {
            if (idioma_lbl === "en") {
            prod_array.push(10429); //glycolic aha
            prod_array.push(10274); //salicylic biome
            } else {
            prod_array.push(201); //glycolic aha
            prod_array.push(9946); //salicylic biome
            }
          } else if (skin === "sensible") {
            if (idioma_lbl === "en") {
            prod_array.push(10416); //retinol 015
            prod_array.push(10276); //ha b5 mask
            } else {
            prod_array.push(198); //retinol 015
            prod_array.push(9990); //ha b5 mask
            }
          } else if (skin === "seca" && age <= 45) {
            if (idioma_lbl === "en") {
            prod_array.push(10429); //glycolic aha
            prod_array.push(10338); //ha hibiscus
            } else {
            prod_array.push(201); //glycolic aha
            prod_array.push(9915); //ha hibiscus
            }
          } else {
            if (idioma_lbl === "en") {
            prod_array.push(10341); //retinol 03
            prod_array.push(10395); //ceramides cream
            } else {
            prod_array.push(9968); //retinol 03
            prod_array.push(9991); //ceramides cream
            }
          }
          break;
      }
    }
    // update products array
    setProductsIds(prod_array);
    setRoutineIds(rutina_array);
  };

  // evaluate products for both routines
  // and push into products array
  React.useEffect(() => {
    evaluate_purpose(purpose, age, skin);
  }, []);

  /*
  React.useEffect(() => {
    console.log("product api resp are", products_api);
  }, [products_api]);
  */

  // map promises over product ids
  // and perform api calls for product details
  React.useEffect(() => {
    let promises = products_ids.map((p) =>
      axios.get(
        `https://labelistcosmetics.me/react-api-mw/v1/labelist/products/${p}`
      )
    );
    // call API
    Promise.all(promises)
      .then((response) => {
        setProductsApi(response);
        setQueryDone(true);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [products_ids]);

  return (
    <div>
      {products_api.length === 0 && (
        <React.Fragment>
          <Skeleton animation="wave" height={80} style={{ marginBottom: 6 }} />
        </React.Fragment>
      )}
      {products_api.length !== 0 && (
        <Typography align="center" variant="h5" gutterBottom>
          {idioma_lbl === "en" ? routine_ids[0].name_en + " routine:" : "Rutina " + routine_ids[0].name_es + ":"}
        </Typography>
      )}
      <Grid container mb={4}>
        <Grid item md={6} p={2}>
          {products_api.length === 0 && <ProductCard loading={true} />}
          {products_api.length !== 0 && (
            <ProductCard
              loading={false}
              product={products_api[0].data}
            />
          )}
        </Grid>
        <Grid item md={6} p={2}>
          {products_api.length === 0 && <ProductCard loading={true} />}
          {products_api.length !== 0 && (
            <ProductCard
              loading={false}
              product={products_api[1].data}
            />
          )}
        </Grid>
      </Grid>
      {has_second_routine && products_api.length === 0 && (
        <React.Fragment>
          <Skeleton animation="wave" height={80} style={{ marginBottom: 6 }} />
        </React.Fragment>
      )}
      {has_second_routine && products_api.length !== 0 && (
        <Typography align="center" variant="h5" gutterBottom>
          {idioma_lbl === "en" ? routine_ids[1].name_en + " routine:" : "Rutina " + routine_ids[1].name_es + ":"}
        </Typography>
      )}
      {has_second_routine && (
        <Grid container>
          <Grid item md={6} p={2}>
            {products_api.length === 0 && <ProductCard loading={true} />}
            {products_api.length !== 0 && (
              <ProductCard
                loading={false}
                product={products_api[2].data}
              />
            )}
          </Grid>
          <Grid item md={6} p={2}>
            {products_api.length === 0 && <ProductCard loading={true} />}
            {products_api.length !== 0 && (
              <ProductCard
                loading={false}
                product={products_api[3].data}
              />
            )}
          </Grid>
        </Grid>
      )}
    </div>
  );
}
